import React from 'react';
import {
  Accordion,
  AccordionSummary,
  NativeSelect,
  AccordionDetails,
  Typography,
  Grid,
  Input,
  Paper,
  InputBase,
  TextField
} from '@material-ui/core';
import InputMask from 'react-input-mask';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Header from '../../../../layout/Header';
import Subheader from '../../../../layout/Subheader';
import Loading from '../../../../components/Loading';

import useStyles from './style';

import GridAncorasContatos from '../components/GridAncorasContatos';
import GridAncorasImportacoesTitulos from '../components/GridAncorasImportacoesTitulos';
import GridAncorasLojas from '../components/GridAncorasLojas';
import GridAncorasTaxasFaixas from '../components/GridAncorasTaxasFaixas';
import PhoneMask from '../../../Collaborator/components/PhoneMask'

import { formatDateToRender, capitalizeFirstLetter } from '../../../../utils/functions';

function Render({
  ancoraId,
  inputs,
  handleInputChange,
  getLoading,
  onSubmit,
  findAllAncorasContatos,
  getAncorasContatos,
  getAncorasLoadingContatos,
  getStatusAncorasContatos,
  setStatusAncorasContatos,

  findAllAncorasLojas,
  getAncorasLojas,
  getAncorasLoadingLojas,
  getStatusAncorasLojas,
  setStatusAncorasLojas,

  findAllAncorasTaxasFaixas,
  getAncorasTaxasFaixas,
  getAncorasLoadingTaxasFaixas,
  getStatusAncorasTaxasFaixas,
  setStatusAncorasTaxasFaixas,
  getErros,
  setErros,
  findCep,
  inputsBlocked,
  getEstados,
  getMunicipios,
  getLayoutsEmailsInteresses,
  getLayoutsEmailsAncoras,
  getLayoutsEmailsAntecipacoes,
  getLayoutsEmailsAntecipacoesAprovadas,
  getLayoutsEmailsAntecipacoesReprovadas,
  getLayoutsEmailsAntecipacoesVencidas,
  getLayoutsArquivoTitulosImportação,
  getLayoutsArquivoTituloExportação,
  getLayoutsEmailsFechamentosMeses,
  destinoOpcoes
}) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Header />
      <Subheader title="Visualizando Rede: " back="/app/ancoras" subanchor={true} />
      <div className={classes.content}>
        <div className={classes.rootForm} style={{ marginLeft: '5%', width: '90%' }}>
          {getLoading ? (
            <Loading />
          ) : (
            <div>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Informações</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid Item xs={1}>
                      <label className={classes.label}>Id</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.inputId}
                          classes={{ input: classes.inputId }}
                          placeholder="AncoraId"
                          value={inputs.ancoraId}
                          name="AncoraId"
                          disabled={true}
                          onBlur={(event) =>
                            getErros.includes('AncoraId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'AncoraId';
                              }),
                            )
                          }
                          error={getErros.includes('AncoraId')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 6,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={5}>
                      <label className={classes.label}>Cnpj</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          value={inputs.cnpj}
                          name="cnpj"
                          className={classes.input}
                          placeholder="Cnpj"
                          disabled={true}
                          onChange={handleInputChange}
                          autocomplete="off"
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Status</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          disabled={true}
                          value={inputs.status}
                          name="status"
                          onChange={handleInputChange}
                          error={getErros.includes('Status')}
                          onBlur={(event) =>
                            getErros.includes('Status') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Status';
                              }),
                            )
                          }
                        >
                          <option value="Ativo">Ativo</option>
                          <option value="Inativo">Inativo</option>
                          <option value="Pendente">Pendente</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Razão Social</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Razão Social"
                          value={inputs.razaoSocial}
                          disabled={true}
                          name="razaoSocial"
                          onBlur={(event) =>
                            getErros.includes('RazaoSocial') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'RazaoSocial';
                              }),
                            )
                          }
                          error={getErros.includes('RazaoSocial')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Nome Fantasia</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Nome Fantasia"
                          disabled={true}
                          value={inputs.nomeFantasia}
                          name="nomeFantasia"
                          onBlur={(event) =>
                            getErros.includes('NomeFantasia') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'NomeFantasia';
                              }),
                            )
                          }
                          error={getErros.includes('NomeFantasia')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            minLength: 3,
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Apelido Rede</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Apelido"
                          value={inputs.apelido}
                          disabled={true}
                          name="apelido"
                          onBlur={(event) =>
                            getErros.includes('apelido') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'apelido';
                              }),
                            )
                          }
                          error={getErros.includes('apelido')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>ERP</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Erp"
                          value={inputs.erp}
                          disabled={true}
                          name="erp"
                          onBlur={(event) =>
                            getErros.includes('Erp') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Erp';
                              }),
                            )
                          }
                          error={getErros.includes('Erp')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            minLength: 3,
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid Item xs={6}>
                      <label className={classes.label}>Departamento Antecipação</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Departamento Antecipação"
                          value={inputs.departamentoAntecipacao}
                          name="departamentoAntecipacao"
                          onBlur={(event) =>
                            getErros.includes('DepartamentoAntecipacao') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'DepartamentoAntecipacao';
                              }),
                            )
                          }
                          error={getErros.includes('DepartamentoAntecipacao')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          disabled={true}
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>

                      <label className={classes.label}>Data abertura empresa</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          value={
                            inputs.dataAberturaEmpresa &&
                            formatDateToRender(inputs.dataAberturaEmpresa)
                          }
                          name="dataAberturaEmpresa"
                          className={classes.input}
                          autocomplete="off"
                          disabled={true}
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Link Domínio Externo</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          className={classes.input}
                          placeholder="Link Domínio Externo"
                          value={inputs.linkDominioExterno}
                          disabled={true}
                          name="linkDominioExterno"
                          onBlur={(event) =>
                            getErros.includes('LinkDominioExterno') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LinkDominioExterno';
                              }),
                            )
                          }
                          error={getErros.includes('LinkDominioExterno')}
                          onChange={handleInputChange}
                          inputProps={{
                            maxLength: 200,
                          }}
                          autoComplete="off"
                        />
                      </Paper>
                      <label className={classes.label}>Telefone Comercial</label>
                      <Paper className={classes.medium} elevation={0}>
                        <PhoneMask
                          value={inputs.telefoneComercialNumero}
                          name="telefoneComercialNumero"
                          autocomplete="off"
                          disabled={true}
                          error={getErros.includes('TelefoneComercialNumero')}
                          onBlur={event => getErros.includes('TelefoneComercialNumero') && setErros(
                            getErros.filter(function (item) {
                              return item !== 'TelefoneComercialNumero'
                            })
                          )}
                          className={classes.input}
                          placeholder="Telefone Comercial"
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={12}>
                      <label className={classes.label}>Tela de Operações Infromações</label>
                      <Paper elevation={0} className={classes.medium}>
                        <TextField
                          multiline
                          rows={5}
                          name="telaDeOperacoesInformacoes"
                          inputProps={{ disableUnderline: true, style: { textTransform: 'uppercase'} }}
                          value={inputs.telaDeOperacoesInformacoes}
                          disabled={true}
                          onChange={handleInputChange}
                          error={getErros.includes('TelaDeOperacoesInformacoes')}
                          onBlur={event => getErros.includes('TelaDeOperacoesInformacoes') && setErros(
                            getErros.filter(function (item) {
                              return item !== 'TelaDeOperacoesInformacoes'
                            })
                          )}
                          className={classes.input}
                          style={{ height: 'auto' }}
                        />
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Financeiro</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <Grid container>
                        <Grid item xs={6}>
                          <label className={classes.label}>
                            CDI com Atualização Automática
                          </label>
                          <Paper className={classes.medium} elevation={0}>
                            <NativeSelect
                              className={classes.input}
                              value={inputs.custoCdiAtualizacaoAutomatica}
                              name="custoCdiAtualizacaoAutomatica"
                              disabled={true}
                              onChange={handleInputChange}
                              error={getErros.includes('custoCdiAtualizacaoAutomatica')}
                              onBlur={(event) =>
                                getErros.includes('custoCdiAtualizacaoAutomatica') &&
                                setErros(
                                  getErros.filter(function (item) {
                                    return item !== 'custoCdiAtualizacaoAutomatica';
                                  }),
                                )
                              }
                            >
                              <option value={1}>
                                Sim
                              </option>
                              <option selected value={0}>Não</option>
                            </NativeSelect>
                          </Paper>
                        </Grid>
                        <Grid item xs={6}>
                          <label className={classes.label}>Custo CDI</label>
                          <Paper className={classes.medium} elevation={0}>
                            <InputBase
                              style={{ textTransform: 'uppercase !important' }}
                              className={classes.input}
                              classes={{ input: classes.inputText }}
                              placeholder="Custo CDI"
                              value={`${inputs.custoCdi} %`}
                              disabled={true}
                              name="custoCdi"
                              onBlur={(event) =>
                                getErros.includes('CustoCdi') &&
                                setErros(
                                  getErros.filter(function (item) {
                                    return item !== 'CustoCdi';
                                  }),
                                )
                              }
                              readOnly
                              error={getErros.includes('CustoCdi')}
                              onChange={handleInputChange}
                              autoComplete="off"
                              inputProps={{
                                minLength: 3,
                                maxLength: 100,
                              }}
                            />
                          </Paper>
                        </Grid>
                      </Grid>
                      <label className={classes.label}>Taxa percentual mínimo rede</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          disabled={true}
                          placeholder="Taxa percentual mínimo rede"
                          value={`${inputs.taxaPercentualMinimoAncora} %`}
                          name="taxaPercentualMinimoAncora"
                          onBlur={(event) =>
                            getErros.includes('TaxaPercentualMinimoAncora') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'TaxaPercentualMinimoAncora';
                              }),
                            )
                          }
                          readOnly
                          error={getErros.includes('TaxaPercentualMinimoAncora')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            minLength: 3,
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                      <label className={classes.label}>Taxa media mínimo mês rede</label>
                      <Paper className={classes.medium} elevation={0}>
                      <InputBase
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          disabled={true}
                          placeholder="Taxa Media Mínimo Mês Rede"
                          value={`${inputs.taxaMediaMinimoMesRede} %`}
                          name="taxaMediaMinimoMesRede"
                          onBlur={(event) =>
                            getErros.includes('TaxaMediaMinimoMesRede') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'TaxaMediaMinimoMesRede';
                              }),
                            )
                          }
                          readOnly
                          error={getErros.includes('TaxaMediaMinimoMesRede')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            minLength: 3,
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                      <label className={classes.label}>Conta corrente limite diário</label>
                      <Paper className={classes.medium} elevation={0}>
                        <CurrencyTextField
                          value={
                            inputs.contaCorrenteLimiteDiario !== '0,00'
                              ? inputs.contaCorrenteLimiteDiario
                              : 0
                          }
                          currencySymbol="R$"
                          placeholder="Conta corrente limite diário"
                          decimalCharacter=","
                          style={{
                            padding: 0,
                            width: '100%',
                          }}
                          modifyValueOnWheel={false}
                          disabled={true}
                          InputProps={{
                            className: classes.inputSalario,
                          }}
                          digitGroupSeparator="."
                          name="contaCorrenteLimiteDiario"
                          error={getErros.includes('ContaCorrenteLimiteDiario')}
                          onChange={handleInputChange}
                          onBlur={(event) =>
                            getErros.includes('ContaCorrenteLimiteDiario') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ContaCorrenteLimiteDiario';
                              }),
                            )
                          }
                        />
                      </Paper>
                      <label className={classes.label}>Destino de Pagamento</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.destinoPagamentoId}
                          name="destinoPagamentoId"
                          disabled={true}
                          onChange={handleInputChange}
                          error={getErros.includes('destinoPagamentoId')}
                          onBlur={(event) =>
                            getErros.includes('destinoPagamentoId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'destinoPagamentoId';
                              }),
                            )
                          }
                        >
                          {destinoOpcoes.map((destino) => (
                            <option key={destino.destinoPagamentoId} value={destino.destinoPagamentoId.toString()}>
                              {capitalizeFirstLetter(destino.destinoPagamento)}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                      <label className={classes.label}>Valor Tarifa Bancaria (FIDC)</label>
                      <Paper className={classes.medium} elevation={0}>
                        <CurrencyTextField
                          value={
                            inputs.bancoFidcValorTarifaBancaria !== '0,00'
                              ? inputs.bancoFidcValorTarifaBancaria
                              : 0
                          }
                          currencySymbol="R$"
                          placeholder="Valor Tarifa Bancaria (FIDC)"
                          decimalCharacter=","
                          style={{
                            padding: 0,
                            width: '100%',
                          }}
                          InputProps={{
                            className: classes.inputSalario,
                          }}
                          modifyValueOnWheel={false}
                          disabled={true}
                          digitGroupSeparator="."
                          name="bancoFidcValorTarifaBancaria"
                          error={getErros.includes('BancoFidcValorTarifaBancaria')}
                          onChange={handleInputChange}
                          onBlur={(event) =>
                            getErros.includes('BancoFidcValorTarifaBancaria') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'BancoFidcValorTarifaBancaria';
                              }),
                            )
                          }
                        />
                      </Paper>
                      <label className={classes.label}>Questionar Fornecedor Aceita Abatimentos/Descontos</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          disabled={true}
                          className={classes.input}
                          value={inputs.questionarFornecedoresAceitaAbatimentosDescontos}
                          name="questionarFornecedoresAceitaAbatimentosDescontos"
                          onChange={handleInputChange}
                          error={getErros.includes('QuestionarFornecedoresAceitaAbatimentosDescontos')}
                          onBlur={(event) =>
                            getErros.includes('QuestionarFornecedoresAceitaAbatimentosDescontos') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'QuestionarFornecedoresAceitaAbatimentosDescontos';
                              }),
                            )
                          }
                        >
                          <option value="Nao">Não</option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                      <label className={classes.label}>Tipos Dados Bancarios</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.tiposDadosBancarios}
                            name="tiposDadosBancarios"
                            onChange={handleInputChange}
                            disabled={true}
                            error={getErros.includes('tiposDadosBancarios')}
                            onBlur={(event) =>
                              getErros.includes('tiposDadosBancarios') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'tiposDadosBancarios';
                                }),
                              )
                            }
                          >
                            <option selected value="Todos">
                              Todos
                            </option>
                            <option value="SomenteDadosBancarios">Somente Dados Bancarios</option>
                            <option value="SomentePix">Somente Pix</option>
                          </NativeSelect>
                        </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Mínimo dias para pagamento</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          type="text"
                          className={classes.input}
                          placeholder="Mínimo dias para pagamento"
                          name="minimoDiasParaPagamento"
                          autocomplete="off"
                          onBlur={(event) =>
                            getErros.includes('MinimoDiasParaPagamento') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'MinimoDiasParaPagamento';
                              }),
                            )
                          }
                          error={getErros.includes('MinimoDiasParaPagamento')}
                          inputProps={{
                            maxLength: 2,
                          }}
                          value={inputs.minimoDiasParaPagamento}
                          disabled={true}
                          onChange={(event) => {
                            if (event.target.value !== '') {
                              if (/^[0-9\b]+$/.test(event.target.value)) {
                                handleInputChange(event);
                              }
                            } else {
                              handleInputChange(event);
                            }
                          }}
                        />
                      </Paper>

                      <label className={classes.label}>Taxa percentual mínimo capittale</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          style={{ textTransform: 'uppercase !important' }}
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Trava percentual mínimo rede"
                          value={`${inputs.taxaPercentualMinimoCapittale} %`}
                          name="taxaPercentualMinimoCapittale"
                          onBlur={(event) =>
                            getErros.includes('TaxaPercentualMinimoCapittale') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'TaxaPercentualMinimoCapittale';
                              }),
                            )
                          }
                          readOnly
                          error={getErros.includes('TaxaPercentualMinimoCapittale')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            minLength: 3,
                            maxLength: 100,
                          }}
                        />
                      </Paper>

                      <label className={classes.label}>Conta corrente limite mensal</label>
                      <Paper className={classes.medium} elevation={0}>
                        <CurrencyTextField
                          value={
                            inputs.contaCorrenteLimiteMensal !== '0,00'
                              ? inputs.contaCorrenteLimiteMensal
                              : 0
                          }
                          currencySymbol="R$"
                          placeholder="Conta corrente limite mensal"
                          decimalCharacter=","
                          disabled={true}
                          style={{
                            padding: 0,
                            width: '100%',
                          }}
                          InputProps={{
                            className: classes.inputSalario,
                          }}
                          modifyValueOnWheel={false}
                          digitGroupSeparator="."
                          name="contaCorrenteLimiteMensal"
                          error={getErros.includes('ContaCorrenteLimiteMensal')}
                          onChange={handleInputChange}
                          onBlur={(event) =>
                            getErros.includes('ContaCorrenteLimiteMensal') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ContaCorrenteLimiteMensal';
                              }),
                            )
                          }
                        />
                      </Paper>
                      <label className={classes.label}>Valor Mínimo para Qualificado</label>
                      <Paper className={classes.medium} elevation={0}>
                        <CurrencyTextField
                          value={
                            inputs.valorMinimoParaQualificado !== '0,00'
                              ? inputs.valorMinimoParaQualificado
                              : 0
                          }
                          currencySymbol="R$"
                          placeholder="Valor Mínimo para Qualificado"
                          decimalCharacter=","
                          style={{
                            padding: 0,
                            width: '100%',
                          }}
                          InputProps={{
                            className: classes.inputSalario,
                          }}
                          modifyValueOnWheel={false}
                          disabled={true}
                          digitGroupSeparator="."
                          name="valorMinimoParaQualificado"
                          error={getErros.includes('ValorMinimoParaQualificado')}
                          onChange={handleInputChange}
                          onBlur={(event) =>
                            getErros.includes('ValorMinimoParaQualificado') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ValorMinimoParaQualificado';
                              }),
                            )
                          }
                        />
                      </Paper>
                      <label className={classes.label}>Valor Mínimo para não Qualificado</label>
                      <Paper className={classes.medium} elevation={0}>
                        <CurrencyTextField
                          value={
                            inputs.valorMinimoParaNaoQualificado !== '0,00'
                              ? inputs.valorMinimoParaNaoQualificado
                              : 0
                          }
                          currencySymbol="R$"
                          placeholder="Valor Mínimo para não Qualificado"
                          decimalCharacter=","
                          style={{
                            padding: 0,
                            width: '100%',
                          }}
                          InputProps={{
                            className: classes.inputSalario,
                          }}
                          modifyValueOnWheel={false}
                          disabled={true}
                          digitGroupSeparator="."
                          name="valorMinimoParaNaoQualificado"
                          error={getErros.includes('ValorMinimoParaNaoQualificado')}
                          onChange={handleInputChange}
                          onBlur={(event) =>
                            getErros.includes('ValorMinimoParaNaoQualificado') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ValorMinimoParaNaoQualificado';
                              }),
                            )
                          }
                        />
                      </Paper>
                      <label className={classes.label}>Obriga Digito Agencia</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          disabled={true}
                          className={classes.input}
                          value={inputs.obrigaDigitoAgencia}
                          name="obrigaDigitoAgencia"
                          onChange={handleInputChange}
                          error={getErros.includes('ObrigaDigitoAgencia')}
                          onBlur={(event) =>
                            getErros.includes('ObrigaDigitoAgencia') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ObrigaDigitoAgencia';
                              }),
                            )
                          }
                        >
                          <option value="Nao">Não</option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                      <label className={classes.label}>Tipos Resumo Diario</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.tipoResumoDiario}
                          name="tipoResumoDiario"
                          disabled={true}
                          onChange={handleInputChange}
                          error={getErros.includes('tipoResumoDiario')}
                          onBlur={(event) =>
                            getErros.includes('tipoResumoDiario') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'tipoResumoDiario';
                              }),
                            )
                          }
                        >
                          <option value="Desativado">
                            Desativado
                          </option>
                          <option value="TodasAsAntecipacoes">Todas as Antecipações</option>
                          <option selected value="ApenasPagamentoDMais1">Apenas Pagamento de Mais 1</option>
                        </NativeSelect>
                      </Paper>
                      <label className={classes.label}>Controla Corporate</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.controlaCorporate}
                          name="controlaCorporate"
                          onChange={handleInputChange}
                          disabled={true}
                          error={getErros.includes('ControlaCorporate')}
                          onBlur={(event) =>
                            getErros.includes('ControlaCorporate') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ControlaCorporate';
                              }),
                            )
                          }
                        >
                          <option selected value="Nao">
                            Não
                          </option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>
                    Importação de arquivo de titulos
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={12}>
                      <label className={classes.label}>Importação Via</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          disabled={true}
                          value={inputs.importacaoVia || 'Arquivo'}
                          name="importacaoVia"
                          onChange={handleInputChange}
                        >
                          <option value="Arquivo">Arquivo</option>
                          <option value="Api">Api</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Layout arquivos titulos importacao</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          disabled={true}
                          className={classes.input}
                          value={inputs.layoutArquivoImportacaoId}
                          name="LayoutArquivoImportacaoId"
                          onChange={handleInputChange}
                          error={getErros.includes('LayoutArquivoImportacaoId')}
                          onBlur={(event) =>
                            getErros.includes('LayoutArquivoImportacaoId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LayoutArquivoImportacaoId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsArquivoTitulosImportação.map(
                            (layoutsArquivoTitulosImportação) => (
                              <option
                                key={layoutsArquivoTitulosImportação.layoutArquivoImportacaoId}
                                value={layoutsArquivoTitulosImportação.layoutArquivoImportacaoId}
                              >
                                {layoutsArquivoTitulosImportação.nome}
                              </option>
                            ),
                          )}
                        </NativeSelect>
                      </Paper>
                      <label className={classes.label}>Nome pasta arquivos titulos</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          disabled={true}
                          className={classes.input}
                          placeholder="Nome Pasta Arquivo Titulos"
                          value={inputs.nomePastaArquivos}
                          name="NomePastaArquivos"
                          classes={{ input: classes.inputText }}
                          onBlur={(event) =>
                            getErros.includes('NomePastaArquivos') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'NomePastaArquivos';
                              }),
                            )
                          }
                          error={getErros.includes('NomePastaArquivos')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                      <label className={classes.label}>Tipo Loja Codigo</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          disabled={true}
                          className={classes.input}
                          value={inputs.tipoLojaCodigo}
                          name="TipoLojaCodigo"
                          onChange={handleInputChange}
                          error={getErros.includes('TipoLojaCodigo')}
                          onBlur={(event) =>
                            getErros.includes('TipoLojaCodigo') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'TipoLojaCodigo';
                              }),
                            )
                          }
                        >
                          <option value="Alfabetico">Alfabético</option>
                          <option value="Numerico">Numérico</option>
                        </NativeSelect>
                      </Paper>
                      <label className={classes.label}>Enviar Emails de Interesse Após Processar Arquivo</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          disabled={true}
                          className={classes.input}
                          value={inputs.enviarEmailsDeInteresseAposProcessarArquivo }
                          name="enviarEmailsDeInteresseAposProcessarArquivo"
                          onChange={handleInputChange}
                          error={getErros.includes('EnviarEmailsDeInteresseAposProcessarArquivo')}
                          onBlur={(event) =>
                            getErros.includes('EnviarEmailsDeInteresseAposProcessarArquivo') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EnviarEmailsDeInteresseAposProcessarArquivo';
                              }),
                            )
                          }
                        >
                          <option selected value="Nao">
                            Não
                          </option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Processando arquivo</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          disabled={true}
                          className={classes.input}
                          value={inputs.processandoArquivo}
                          name="ProcessandoArquivo"
                          onChange={handleInputChange}
                          error={getErros.includes('ProcessandoArquivo')}
                          onBlur={(event) =>
                            getErros.includes('ProcessandoArquivo') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ProcessandoArquivo';
                              }),
                            )
                          }
                        >
                          <option value="Nao">Não</option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                      <label className={classes.label}>Vencimento de Titulo em Dias</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          type="text"
                          className={classes.input}
                          disabled={true}
                          placeholder="Vencimento Titulo Em Dias"
                          name="vencimentoTituloEmDMais"
                          autocomplete="off"
                          onBlur={(event) =>
                            getErros.includes('VencimentoTituloEmDMais') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'VencimentoTituloEmDMais';
                              }),
                            )
                          }
                          error={getErros.includes('VencimentoTituloEmDMais')}
                          value={inputs.vencimentoTituloEmDMais}
                          onChange={(event) => {
                            if (event.target.value !== '') {
                              if (/^[0-9\b]+$/.test(event.target.value)) {
                                handleInputChange(event);
                              }
                            } else {
                              handleInputChange(event);
                            }
                          }}
                        />
                      </Paper>
                      <label className={classes.label}>Controla loja</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          disabled={true}
                          className={classes.input}
                          value={inputs.controlaLoja}
                          name="ControlaLoja"
                          onChange={handleInputChange}
                          error={getErros.includes('ControlaLoja')}
                          onBlur={(event) =>
                            getErros.includes('ControlaLoja') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ControlaLoja';
                              }),
                            )
                          }
                        >
                          <option value="Nao">Não</option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                      <label className={classes.label}>Enviar WhatsApp Após Processar Arquivo</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          disabled={true}
                          className={classes.input}
                          value={inputs.enviarWhatsAppAposProcessarArquivo}
                          name="enviarWhatsAppAposProcessarArquivo"
                          onChange={handleInputChange}
                          error={getErros.includes('EnviarWhatsAppAposProcessarArquivo')}
                          onBlur={(event) =>
                            getErros.includes('EnviarWhatsAppAposProcessarArquivo') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EnviarWhatsAppAposProcessarArquivo';
                              }),
                            )
                          }
                        >
                          <option selected value="Nao">
                            Não
                          </option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>
                    Exportação propostas aprovadas
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Layout arquivos titulos exportação</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          disabled={true}
                          className={classes.input}
                          value={inputs.layoutArquivoExportacaoId}
                          name="LayoutArquivoExportacaoId"
                          onChange={handleInputChange}
                          error={getErros.includes('LayoutArquivoExportacaoId')}
                          onBlur={(event) =>
                            getErros.includes('LayoutArquivoExportacaoId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LayoutArquivoExportacaoId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsArquivoTituloExportação.map(
                            (layoutsArquivoTitulosExportação) => (
                              <option
                                key={layoutsArquivoTitulosExportação.layoutArquivoExportacaoId}
                                value={layoutsArquivoTitulosExportação.layoutExportacaoId}
                              >
                                {layoutsArquivoTitulosExportação.nome}
                              </option>
                            ),
                          )}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                        <label className={classes.label}>Enviar Arquivo Exportação na Aprovação</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            disabled={true}
                            className={classes.input}
                            value={inputs.enviarArquivoExportacaoNaAprovacao}
                            name="enviarArquivoExportacaoNaAprovacao"
                            onChange={handleInputChange}
                            error={getErros.includes('EnviarArquivoExportacaoNaAprovacao')}
                            onBlur={(event) =>
                              getErros.includes('EnviarArquivoExportacaoNaAprovacao') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'EnviarArquivoExportacaoNaAprovacao';
                                }),
                              )
                            }
                          >
                            <option selected value="Nao">
                              Não
                            </option>
                            <option value="Sim">Sim</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Ftp status</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          disabled={true}
                          value={inputs.ftpStatus}
                          name="ftpStatus"
                          onChange={handleInputChange}
                          error={getErros.includes('ftpStatus')}
                          onBlur={(event) =>
                            getErros.includes('ftpStatus') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ftpStatus';
                              }),
                            )
                          }
                        >
                          <option selected value="Inativo">
                            Inativo
                          </option>
                          <option value="Ativo">Ativo</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                        <label className={classes.label}>Envio Automático Propostas Aprovadas Para a Rede</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            disabled={true}
                            className={classes.input}
                            value={inputs.envioAutomaticoPropostasAprovadas}
                            name="envioAutomaticoPropostasAprovadas"
                            onChange={handleInputChange}
                            error={getErros.includes('EnvioAutomaticoPropostasAprovadas')}
                            onBlur={(event) =>
                              getErros.includes('EnvioAutomaticoPropostasAprovadas') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'EnvioAutomaticoPropostasAprovadas';
                                }),
                              )
                            }
                          >
                            <option selected value="Nao">
                              Não
                            </option>
                            <option value="SimComEmail">Sim, com e-mail</option>
                            <option value="SimSemEmail">Sim, sem e-mail</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Ftp User Name</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          className={classes.input}
                          placeholder="Ftp User Name"
                          disabled={true}
                          value={inputs.ftpUserName}
                          name="ftpUserName"
                          onBlur={(event) =>
                            getErros.includes('FtpUserName') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'FtpUserName';
                              }),
                            )
                          }
                          error={getErros.includes('FtpUserName')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Ftp Password</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          className={classes.input}
                          placeholder="Ftp Password"
                          value={inputs.ftpPassword ? '********' : ''}
                          disabled={true}
                          name="ftpPassword"
                          onBlur={(event) =>
                            getErros.includes('FtpPassword') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'FtpPassword';
                              }),
                            )
                          }
                          error={getErros.includes('FtpPassword')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Ftp protocolo</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.ftpProtocolo}
                          disabled={true}
                          name="ftpProtocolo"
                          onChange={handleInputChange}
                          error={getErros.includes('ftpProtocolo')}
                          onBlur={(event) =>
                            getErros.includes('ftpProtocolo') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ftpProtocolo';
                              }),
                            )
                          }
                        >
                          <option selected value="Ftp">
                            Ftp
                          </option>
                          <option value="Sftp">Sftp</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Ftp Host</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          disabled={true}
                          className={classes.input}
                          placeholder="Ftp Host"
                          value={inputs.ftpHost}
                          name="ftpHost"
                          onBlur={(event) =>
                            getErros.includes('FtpHost') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'FtpHost';
                              }),
                            )
                          }
                          error={getErros.includes('FtpHost')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Ftp Port</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          className={classes.input}
                          placeholder="Ftp Port"
                          value={inputs.ftpPort}
                          disabled={true}
                          name="ftpPort"
                          type="number"
                          classes={{ input: classes.inputText }}
                          onBlur={(event) =>
                            getErros.includes('FtpPort') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ftpPort';
                              }),
                            )
                          }
                          error={getErros.includes('ftpPort')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 6,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Ftp Directory</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          className={classes.input}
                          placeholder="Ftp Directory"
                          value={inputs.ftpDirectory}
                          disabled={true}
                          name="ftpDirectory"
                          classes={{ input: classes.inputText }}
                          onBlur={(event) =>
                            getErros.includes('FtpDirectory') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'FtpDirectory';
                              }),
                            )
                          }
                          error={getErros.includes('FtpDirectory')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Informações de e-mail</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <Grid item xs={6}>
                        <label className={classes.label}>E-mail Exchange</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.emailExchange}
                            name="emailExchange"
                            disabled={true}
                            onChange={handleInputChange}
                            error={getErros.includes('EmailExchange')}
                            onBlur={(event) =>
                              getErros.includes('EmailExchange') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'EmailExchange';
                                }),
                              )
                            }
                          >
                            <option value="Nao">Não</option>
                            <option value="Exchange2007_SP1">Exchange 2007_SP1</option>
                            <option value="Exchange2010">Exchange 2010</option>
                            <option value="Exchange2010_SP1">Exchange 2010_SP1</option>
                            <option value="Exchange2010_SP2">Exchange 2010_SP2</option>
                            <option value="Exchange2013">Exchange 2013</option>
                            <option value="Exchange2013_SP1">Exchange 2013_SP1</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>E-mail Authentication</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.emailAuthentication}
                            name="emailAuthentication"
                            onChange={handleInputChange}
                            disabled={true}
                            error={getErros.includes('EmailAuthentication')}
                            onBlur={(event) =>
                              getErros.includes('EmailAuthentication') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'EmailAuthentication';
                                }),
                              )
                            }
                          >
                            <option value="Desabilitado">Desabilitado</option>
                            <option value="Habilitado">Habilitado</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>E-mail Secure</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={inputs.emailSecure}
                            name="emailSecure"
                            onChange={handleInputChange}
                            disabled={true}
                            error={getErros.includes('EmailSecure')}
                            onBlur={(event) =>
                              getErros.includes('EmailSecure') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'EmailSecure';
                                }),
                              )
                            }
                          >
                            <option value="Desabilitado">Desabilitado</option>
                            <option value="Habilitado">Habilitado</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <Grid item xs={6}>
                        <label className={classes.label}>E-mail Antecipação</label>
                        <Paper className={classes.medium} elevation={0}>
                          <InputBase
                            className={classes.input}
                            placeholder="E-mail Antecipação"
                            value={inputs.emailAntecipacao}
                            name="emailAntecipacao"
                            classes={{ input: classes.inputEmail }}
                            onBlur={(event) =>
                              getErros.includes('EmailAntecipacao') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'EmailAntecipacao';
                                }),
                              )
                            }
                            disabled={true}
                            error={getErros.includes('EmailAntecipacao')}
                            onChange={handleInputChange}
                            autoComplete="off"
                            inputProps={{
                              maxLength: 100,
                            }}
                          />
                        </Paper>
                      </Grid>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail UserName</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          className={classes.input}
                          placeholder="E-mail UserName"
                          value={inputs.emailUserName}
                          name="emailUserName"
                          disabled={true}
                          classes={{ input: classes.inputEmail }}
                          onBlur={(event) =>
                            getErros.includes('EmailUserName') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailUserName';
                              }),
                            )
                          }
                          error={getErros.includes('EmailUserName')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail Password</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          className={classes.input}
                          placeholder="E-mail Password"
                          value={inputs.emailPassword}
                          disabled={true}
                          name="emailPassword"
                          onBlur={(event) =>
                            getErros.includes('EmailPassword') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailPassword';
                              }),
                            )
                          }
                          error={getErros.includes('EmailPassword')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail Host</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          className={classes.input}
                          placeholder="E-mail Host"
                          value={inputs.emailHost}
                          name="emailHost"
                          classes={{ input: classes.inputEmail }}
                          disabled={true}
                          onBlur={(event) =>
                            getErros.includes('EmailHost') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailHost';
                              }),
                            )
                          }
                          error={getErros.includes('EmailHost')}
                          onChange={handleInputChange}
                          autoComplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>E-mail Port</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          type="text"
                          className={classes.input}
                          placeholder="E-mail Port"
                          name="emailPort"
                          autocomplete="off"
                          disabled={true}
                          onBlur={(event) =>
                            getErros.includes('EmailPort') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailPort';
                              }),
                            )
                          }
                          error={getErros.includes('EmailPort')}
                          inputProps={{
                            maxLength: 6,
                          }}
                          value={inputs.emailPort}
                          onChange={(event) => {
                            if (event.target.value !== '') {
                              if (/^[0-9\b]+$/.test(event.target.value)) {
                                handleInputChange(event);
                              }
                            } else {
                              handleInputChange(event);
                            }
                          }}
                        />
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Layouts Emails</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Layout e-mail Rede</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          disabled={true}
                          value={inputs.layoutEmailAncoraId}
                          name="layoutEmailAncoraId"
                          onChange={handleInputChange}
                          error={getErros.includes('LayoutEmailAncoraId')}
                          onBlur={(event) =>
                            getErros.includes('LayoutEmailAncoraId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LayoutEmailAncoraId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsEmailsAncoras.map((layoutEmailAncora) => (
                            <option
                              key={layoutEmailAncora.layoutEmailAncoraId}
                              value={layoutEmailAncora.layoutEmailAncoraId}
                            >
                              {layoutEmailAncora.nome}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                      <label className={classes.label}>Layout e-mail fornecedor</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          disabled={true}
                          value={inputs.layoutEmailFornecedorId}
                          name="layoutEmailFornecedorId"
                          onChange={handleInputChange}
                          error={getErros.includes('LayoutEmailFornecedorId')}
                          onBlur={(event) =>
                            getErros.includes('LayoutEmailFornecedorId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LayoutEmailFornecedorId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsEmailsAntecipacoes.map((layoutEmailFornecedor) => (
                            <option
                              key={layoutEmailFornecedor.layoutEmailFornecedorId}
                              value={layoutEmailFornecedor.layoutEmailFornecedorId}
                            >
                              {layoutEmailFornecedor.nome}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                      <label className={classes.label}>Layout e-mail antecipacao aprovada</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.layoutEmailAntecipacaoAprovadaId}
                          disabled={true}
                          name="layoutEmailAntecipacaoAprovadaId"
                          onChange={handleInputChange}
                          error={getErros.includes('LayoutEmailAntecipacaoAprovadaId')}
                          onBlur={(event) =>
                            getErros.includes('LayoutEmailAntecipacaoAprovadaId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LayoutEmailAntecipacaoAprovadaId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsEmailsAntecipacoesAprovadas.map(
                            (layoutEmailAntecipacaoAprovada) => (
                              <option
                                key={
                                  layoutEmailAntecipacaoAprovada.layoutEmailAntecipacaoAprovadaId
                                }
                                value={
                                  layoutEmailAntecipacaoAprovada.layoutEmailAntecipacaoAprovadaId
                                }
                              >
                                {layoutEmailAntecipacaoAprovada.nome}
                              </option>
                            ),
                          )}
                        </NativeSelect>
                      </Paper>
                      <label className={classes.label}>Layout e-mail antecipacao vencida</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.layoutEmailAntecipacaoVencidaId}
                          disabled={true}
                          name="layoutEmailAntecipacaoVencidaId"
                          onChange={handleInputChange}
                          error={getErros.includes('LayoutEmailAntecipacaoVencidaId')}
                          onBlur={(event) =>
                            getErros.includes('LayoutEmailAntecipacaoVencidaId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LayoutEmailAntecipacaoVencidaId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsEmailsAntecipacoesVencidas.map(
                            (layoutEmailAntecipacaoVencida) => (
                              <option
                                key={layoutEmailAntecipacaoVencida.layoutEmailAntecipacaoVencidaId}
                                value={
                                  layoutEmailAntecipacaoVencida.layoutEmailAntecipacaoVencidaId
                                }
                              >
                                {layoutEmailAntecipacaoVencida.nome}
                              </option>
                            ),
                          )}
                        </NativeSelect>
                      </Paper>
                    </Grid>

                    <Grid item xs={6} className={classes.item}>
                      <label className={classes.label}>Layout e-mail Fechamento Mês</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.layoutEmailFechamentoMesId}
                          disabled={true}
                          name="LayoutEmailFechamentoMesId"
                          onChange={handleInputChange}
                          error={getErros.includes('LayoutEmailFechamentoMesId')}
                          onBlur={(event) =>
                            getErros.includes('LayoutEmailFechamentoMesId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LayoutEmailFechamentoMesId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsEmailsFechamentosMeses?.map((layoutsEmailsFechamentoMeses) => (
                            <option
                              key={layoutsEmailsFechamentoMeses.layoutEmailFechamentoMesId}
                              value={layoutsEmailsFechamentoMeses.layoutEmailFechamentoMesId}
                            >
                              {layoutsEmailsFechamentoMeses.nome}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                      <label className={classes.label}>Layout e-mail interesse</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.layoutEmailInteresseId}
                          name="layoutEmailInteresseId"
                          disabled={true}
                          onChange={handleInputChange}
                          error={getErros.includes('LayoutEmailInteresseId')}
                          onBlur={(event) =>
                            getErros.includes('LayoutEmailInteresseId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LayoutEmailInteresseId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsEmailsInteresses.map((layoutsEmailsInteresses) => (
                            <option
                              key={layoutsEmailsInteresses.layoutEmailInteresseId}
                              value={layoutsEmailsInteresses.layoutEmailInteresseId}
                            >
                              {layoutsEmailsInteresses.nome}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                      <label className={classes.label}>Layout e-mail antecipacao reprovada</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.layoutEmailAntecipacaoReprovadaId}
                          name="layoutEmailAntecipacaoReprovadaId"
                          onChange={handleInputChange}
                          disabled={true}
                          error={getErros.includes('LayoutEmailAntecipacaoReprovadaId')}
                          onBlur={(event) =>
                            getErros.includes('LayoutEmailAntecipacaoReprovadaId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'LayoutEmailAntecipacaoReprovadaId';
                              }),
                            )
                          }
                        >
                          <option value="0">FALTA PREENCHER</option>
                          {getLayoutsEmailsAntecipacoesReprovadas.map(
                            (layoutEmailAntecipacaoReprovada) => (
                              <option
                                key={
                                  layoutEmailAntecipacaoReprovada.layoutEmailAntecipacaoReprovadaId
                                }
                                value={
                                  layoutEmailAntecipacaoReprovada.layoutEmailAntecipacaoReprovadaId
                                }
                              >
                                {layoutEmailAntecipacaoReprovada.nome}
                              </option>
                            ),
                          )}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Slip Pagamento</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Ordem titulos</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.ordemTitulos}
                          disabled={true}
                          name="ordemTitulos"
                          onChange={handleInputChange}
                          error={getErros.includes('enumAncorasOrdemTitulos')}
                          onBlur={(event) =>
                            getErros.includes('enumAncorasOrdemTitulos') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'enumAncorasOrdemTitulos';
                              }),
                            )
                          }
                        >
                          <option value="NumeroNotaFiscal">Número nota fiscal</option>
                          <option value="Loja">Loja</option>
                          <option value="Sequencia">Sequencia</option>
                          <option value="DataVencimento">Data Vencimento</option>
                        </NativeSelect>
                      </Paper>

                      <label className={classes.label}>Controle conta bancaria</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.controlaContaBancaria}
                          name="ControlaContaBancaria"
                          disabled={true}
                          onChange={handleInputChange}
                          error={getErros.includes('ControlaContaBancaria')}
                          onBlur={(event) =>
                            getErros.includes('ControlaContaBancaria') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'ControlaContaBancaria';
                              }),
                            )
                          }
                        >
                          <option value="Nao">Não</option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>

                      <label className={classes.label}>Segregado por loja</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.segregadoPorLoja}
                          name="SegregadoPorLoja"
                          disabled={true}
                          onChange={handleInputChange}
                          error={getErros.includes('SegregadoPorLoja')}
                          onBlur={(event) =>
                            getErros.includes('SegregadoPorLoja') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'SegregadoPorLoja';
                              }),
                            )
                          }
                        >
                          <option value="Nao">Não</option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Condição</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.condicao}
                          disabled={true}
                          name="Condicao"
                          onChange={handleInputChange}
                          error={getErros.includes('Condicao')}
                          onBlur={(event) =>
                            getErros.includes('Condicao') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Condicao';
                              }),
                            )
                          }
                        >
                          <option value="Nao">Não</option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>

                      <label className={classes.label}>E-mail ancora agrupado</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.emailAncoraAgrupado}
                          name="EmailAncoraAgrupado"
                          disabled={true}
                          onChange={handleInputChange}
                          error={getErros.includes('EmailAncoraAgrupado')}
                          onBlur={(event) =>
                            getErros.includes('EmailAncoraAgrupado') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EmailAncoraAgrupado';
                              }),
                            )
                          }
                        >
                          <option value="Nao">Não</option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>

                      <label className={classes.label}>
                        Usar razao com o codigo interno do fornecedor
                      </label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.usarRazaoComCodigoInternoFornecedor}
                          name="UsarRazaoComCodigoInternoFornecedor"
                          disabled={true}
                          onChange={handleInputChange}
                          error={getErros.includes('UsarRazaoComCodigoInternoFornecedor')}
                          onBlur={(event) =>
                            getErros.includes('UsarRazaoComCodigoInternoFornecedor') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'UsarRazaoComCodigoInternoFornecedor';
                              }),
                            )
                          }
                        >
                          <option value="Nao">Não</option>
                          <option value="Sim">Sim</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Endereço</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Cep</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          value={inputs.cep}
                          name="cep"
                          className={classes.input}
                          placeholder="Cep"
                          disabled={true}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Logradouro</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Logradouro"
                          name="logradouro"
                          autocomplete="off"
                          inputProps={{
                            maxLength: 100,
                          }}
                          readOnly
                          value={inputs.logradouro}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={6}>
                      <label className={classes.label}>Bairro</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Bairro"
                          name="bairro"
                          readOnly
                          autocomplete="off"
                          onBlur={(event) =>
                            getErros.includes('Bairro') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Bairro';
                              }),
                            )
                          }
                          error={getErros.includes('Bairro')}
                          value={inputs.bairro}
                          inputProps={{
                            maxLength: 50,
                          }}
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Estado</label>
                      <Paper className={classes.medium} elevation={0}>
                        <select
                          className={classes.input}
                          value={inputs.estadoId}
                          name="estadoId"
                          disabled
                          onChange={handleInputChange}
                          error={getErros.includes('EstadoId')}
                          onBlur={(event) =>
                            getErros.includes('EstadoId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'EstadoId';
                              }),
                            )
                          }
                        >
                          <option value="0">Selecione o estado</option>
                          {getEstados.map((estado) => (
                            <option key={estado.estadoId} value={estado.estadoId}>
                              {estado.estado}
                            </option>
                          ))}
                        </select>
                      </Paper>
                    </Grid>

                    <Grid item xs={1}>
                      <label className={classes.label}>Número</label>
                      <Paper className={classes.small} elevation={0}>
                        <InputBase
                          type="number"
                          className={classes.input}
                          placeholder="Número"
                          name="numero"
                          autocomplete="off"
                          onBlur={(event) =>
                            getErros.includes('Complemento') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Complemento';
                              }),
                            )
                          }
                          readOnly
                          error={getErros.includes('Complemento')}
                          inputProps={{
                            maxlength: 6,
                          }}
                          value={inputs.numero}
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={5}>
                      <label className={classes.label}>Complemento</label>
                      <Paper className={classes.medium} elevation={0}>
                        <InputBase
                          className={classes.input}
                          classes={{ input: classes.inputText }}
                          placeholder="Complemento"
                          name="complemento"
                          autocomplete="off"
                          onBlur={(event) =>
                            getErros.includes('Complemento') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Complemento';
                              }),
                            )
                          }
                          readOnly
                          error={getErros.includes('Complemento')}
                          inputProps={{
                            maxLength: 50,
                          }}
                          value={inputs.complemento}
                          onChange={handleInputChange}
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={6}>
                      <label className={classes.label}>Município</label>
                      <Paper className={classes.medium} elevation={0}>
                        <select
                          className={classes.input}
                          value={inputs.municipioId}
                          name="municipioId"
                          onChange={handleInputChange}
                          error={getErros.includes('MunicipioId')}
                          onBlur={(event) =>
                            getErros.includes('MunicipioId') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'MunicipioId';
                              }),
                            )
                          }
                          disabled
                        >
                          <option>Selecione o município</option>
                          {getMunicipios.map((municipio) => (
                            <option key={municipio.municipioId} value={municipio.municipioId}>
                              {municipio.municipio}
                            </option>
                          ))}
                        </select>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Horarios para aprovação de propostas</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details} style={{ flexDirection: 'column' }}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Aprovação após horario limite</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.aprovacaoAposHoraLimite}
                          name="aprovacaoAposHoraLimite"
                          readOnly
                          onChange={handleInputChange}
                          error={getErros.includes('AprovacaoAposHoraLimite')}
                          onBlur={(event) =>
                            getErros.includes('AprovacaoAposHoraLimite') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'AprovacaoAposHoraLimite';
                              }),
                            )
                          }
                          disabled={true}
                        >
                          <option selected value="NaoPermitido">
                            Não permitido
                          </option>
                          <option value="Permitido">Permitido</option>
                          <option value="PermitidoComAutorizacao">Permitido com autorização</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={2}>
                      <label className={classes.label}>Horario Limite - Segunda</label>
                      <Paper className={classes.small} elevation={0}>
                        <InputMask
                          mask="99:99"
                          value={inputs.horaLimiteAceitePropostaSegunda}
                          name="horaLimiteAceitePropostaSegunda"
                          onBlur={(event) =>
                            getErros.includes('HoraLimiteAceitePropostaSegunda') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'HoraLimiteAceitePropostaSegunda';
                              }),
                            )
                          }
                          disabled={true}
                          autoComplete="off"
                          tabIndex={1}
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              placeholder="00:00"
                              name="horaLimiteAceitePropostaSegunda"
                              error={getErros.includes('HoraLimiteAceitePropostaSegunda')}
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>
                    <Grid item xs={2}>
                      <label className={classes.label}>Horario Limite - Terça</label>
                      <Paper className={classes.small} elevation={0}>
                        <InputMask
                          mask="99:99"
                          value={inputs.horaLimiteAceitePropostaTerca}
                          name="horaLimiteAceitePropostaTerca"
                          onBlur={(event) =>
                            getErros.includes('HoraLimiteAceitePropostaTerca') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'HoraLimiteAceitePropostaTerca';
                              }),
                            )
                          }
                          disabled={true}
                          autoComplete="off"
                          tabIndex={1}
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              placeholder="00:00"
                              name="horaLimiteAceitePropostaTerca"
                              error={getErros.includes('HoraLimiteAceitePropostaTerca')}
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>
                    <Grid item xs={2}>
                      <label className={classes.label}>Horario Limite - Quarta</label>
                      <Paper className={classes.small} elevation={0}>
                        <InputMask
                          mask="99:99"
                          value={inputs.horaLimiteAceitePropostaQuarta}
                          name="horaLimiteAceitePropostaQuarta"
                          onBlur={(event) =>
                            getErros.includes('HoraLimiteAceitePropostaQuarta') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'HoraLimiteAceitePropostaQuarta';
                              }),
                            )
                          }
                          disabled={true}
                          autoComplete="off"
                          tabIndex={1}
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              placeholder="00:00"
                              name="horaLimiteAceitePropostaQuarta"
                              error={getErros.includes('HoraLimiteAceitePropostaQuarta')}
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>
                    <Grid item xs={2}>
                      <label className={classes.label}>Horario Limite - Quinta</label>
                      <Paper className={classes.small} elevation={0}>
                        <InputMask
                          mask="99:99"
                          value={inputs.horaLimiteAceitePropostaQuinta}
                          name="horaLimiteAceitePropostaQuinta"
                          onBlur={(event) =>
                            getErros.includes('HoraLimiteAceitePropostaQuinta') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'HoraLimiteAceitePropostaQuinta';
                              }),
                            )
                          }
                          disabled={true}
                          autoComplete="off"
                          tabIndex={1}
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              placeholder="00:00"
                              name="horaLimiteAceitePropostaQuinta"
                              error={getErros.includes('HoraLimiteAceitePropostaQuinta')}
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>
                    <Grid item xs={2}>
                      <label className={classes.label}>Horario Limite - Sexta</label>
                      <Paper className={classes.small} elevation={0}>
                        <InputMask
                          mask="99:99"
                          value={inputs.horaLimiteAceitePropostaSexta}
                          name="horaLimiteAceitePropostaSexta"
                          onBlur={(event) =>
                            getErros.includes('HoraLimiteAceitePropostaSexta') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'HoraLimiteAceitePropostaSexta';
                              }),
                            )
                          }
                          disabled={true}
                          autoComplete="off"
                          tabIndex={1}
                        >
                          {() => (
                            <Input
                              className={classes.input}
                              placeholder="00:00"
                              name="horaLimiteAceitePropostaSexta"
                              error={getErros.includes('HoraLimiteAceitePropostaSexta')}
                            />
                          )}
                        </InputMask>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Configurações</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <Grid item xs={6}>
                      <label className={classes.label}>Ambiente</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={inputs.ambiente}
                          name="Ambiente"
                          onChange={handleInputChange}
                          error={getErros.includes('Ambiente')}
                          onBlur={(event) =>
                            getErros.includes('Ambiente') &&
                            setErros(
                              getErros.filter(function (item) {
                                return item !== 'Ambiente';
                              }),
                            )
                          }
                          disabled={true}
                        >
                          <option value="Desenvolvimento">Desenvolvimento</option>
                          <option value="Producao">Produção</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={6}></Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Logotipo</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    {!!inputs.logotipoLink && (
                      <div className={classes.divLogo}>
                        <img src={inputs.logotipoLink} />
                      </div>
                    )}
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>E-mail assinatura</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    {!!inputs.emailAssinaturaLink && (
                      <div className={classes.divLogo}>
                        <img src={inputs.emailAssinaturaLink} />
                      </div>
                    )}
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion
                onChange={(event, expanded) => {
                  if (expanded && !getAncorasContatos.length) {
                    setStatusAncorasContatos();
                    findAllAncorasContatos();
                  }
                }}
                className={classes.accordionRoot}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Contatos</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    {getAncorasLoadingContatos ? (
                      <Loading />
                    ) : (
                      <GridAncorasContatos
                        ancoraId={ancoraId}
                        visualize
                        findAllAncorasContatos={findAllAncorasContatos}
                        getStatusAncorasContatos={getStatusAncorasContatos}
                        setStatusAncorasContatos={setStatusAncorasContatos}
                        getAncorasContatos={getAncorasContatos}
                      />
                    )}
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion className={classes.accordionRoot}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel-ancoras-importacoes-titulos"
                  id="ancoras-importacoes-titulos"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Integrações de Importação</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    <GridAncorasImportacoesTitulos ancoraId={ancoraId} visualize />
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion
                onChange={(event, expanded) => {
                  if (expanded && !getAncorasTaxasFaixas.length) {
                    setStatusAncorasTaxasFaixas();
                    findAllAncorasTaxasFaixas();
                  }
                }}
                className={classes.accordionRoot}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Taxas Faixas</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    {getAncorasLoadingTaxasFaixas ? (
                      <Loading />
                    ) : (
                      <GridAncorasTaxasFaixas
                        ancoraId={ancoraId}
                        visualize
                        findAllAncorasTaxasFaixas={findAllAncorasTaxasFaixas}
                        getStatusAncorasTaxasFaixas={getStatusAncorasTaxasFaixas}
                        setStatusAncorasTaxasFaixas={setStatusAncorasTaxasFaixas}
                        getAncorasTaxasFaixas={getAncorasTaxasFaixas}
                      />
                    )}
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion
                onChange={(event, expanded) => {
                  if (expanded && !getAncorasLojas.length) {
                    setStatusAncorasLojas();
                    findAllAncorasLojas();
                  }
                }}
                className={classes.accordionRoot}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  className={classes.summary}
                >
                  <Typography className={classes.heading}>Lojas</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container>
                    {getAncorasLoadingLojas ? (
                      <Loading />
                    ) : (
                      <GridAncorasLojas
                        ancoraId={ancoraId}
                        visualize
                        findAllAncorasLojas={findAllAncorasLojas}
                        getStatusAncorasLojas={getStatusAncorasLojas}
                        setStatusAncorasLojas={setStatusAncorasLojas}
                        getAncorasLojas={getAncorasLojas}
                      />
                    )}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Render;
